import { getFormatDTOText } from "@/scripts";
import {List} from "@/models/List";

export class OrderLineDtoList extends List{
  constructor(obj) {
    super(OrderLineDto, obj)
  }
}

export class OrderLineDto {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.fullName = obj?.fullName || null
    this.citizenship = obj?.citizenship || null
    this.studentNumber = obj?.studentNumber || null
    this.courseNumberTo = obj?.courseNumberTo || null
    this.group = obj?.group || null
    this.contractNumber = obj?.contractNumber || null
    this.contractDate = obj?.contractDate || null
    this.basedOn = obj?.basedOn || null
  }

  get contractDateText () {
    return this.contractDate && getFormatDTOText(this.contractDate)
  }
}